import { call, put, takeEvery, all, fork } from "redux-saga/effects";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PropTypes from "prop-types";
import { useTranslation, withTranslation } from "react-i18next";

// Majoration Redux States
import { GET_MAJORATIONS } from "./actionType";

import {
  majorationApiResponseSuccess,
  majorationApiResponseError,
} from "./action";

//Include Both Helper File with needed methods
import { getMajorations as getMajorationsApi } from "../../helpers/fakebackend_helper";

function* getMajorations() {
  try {
    const response = yield call(getMajorationsApi);
    console.log("response get majoration: ", response);
    yield put(majorationApiResponseSuccess(GET_MAJORATIONS, response));
  } catch (error) {
    yield put(majorationApiResponseError(GET_MAJORATIONS, error));
  }
}


export function* watchGetMajorations() {
  yield takeEvery(GET_MAJORATIONS, getMajorations);
}

function* majorationSaga() {
  yield all([fork(watchGetMajorations)]);
}

export default majorationSaga;
